<template>
  <ListingsFilterRange
    :model-value="modelValue"
    :options="options"
    :default-range="DEFAULT_PRICE_RANGE"
    label="Price range (£)"
    @update:model-value="handleUpdateModelValue"
  />
</template>

<script lang="ts" setup>
  // Types
  import type { PropType, ComputedRef } from 'vue';
  import type { TListingsPriceOptions, TQueryRange } from '~/misc/listings/types';
  import { ESaleType } from '~/misc/listings/types';
  import { EAnalyticsEvent } from '~/misc/services/analytics/types';

  // Config
  import { DEFAULT_PRICE_RANGE } from '~/misc/listings/filters/price/config';
  import { LET_LISTINGS_PRICE_OPTIONS, SALE_LISTINGS_PRICE_OPTIONS } from '~/misc/listings/config';

  // Utils
  import { eventBus } from '~/misc/utils/event-bus';

  // Components
  import ListingsFilterRange from '~/misc/listings/filters/range/ListingsFilterRange.vue';

  const emit = defineEmits<{
    (e: 'update:modelValue', value: TQueryRange): void;
  }>();

  const props = defineProps({
    modelValue: {
      type: Object as PropType<TQueryRange>,
      default: (): TQueryRange => DEFAULT_PRICE_RANGE,
    },
    saleType: {
      type: String as PropType<ESaleType>,
      required: true,
    },
  });

  const options: ComputedRef<TListingsPriceOptions> = computed<TListingsPriceOptions>(() =>
    props.saleType === ESaleType.SALES ? SALE_LISTINGS_PRICE_OPTIONS : LET_LISTINGS_PRICE_OPTIONS
  );

  const handleUpdateModelValue = (value: TQueryRange) => {
    eventBus.emit(EAnalyticsEvent.DASHBOARD_FILTERS_PRICE_RANGE_CHANGED, { value });

    emit('update:modelValue', value);
  };

  watch(
    () => props.saleType,
    () => {
      // reset values if sale type changed
      handleUpdateModelValue({ ...DEFAULT_PRICE_RANGE });
    }
  );
</script>
